// AUTO-GENERATED by scripts/generate-build-info.js - do not edit by hand.
// "dev" values mean the app was built without the pipeline stamping step.
export const BUILD_INFO = {
  version: '2.4.0',
  buildNumber: 'dev',
  commit: 'ba248d16',
  branch: 'new_build_apk',
  builtAt: '2026-09-06T12:54:19.194Z',
} as const;

/** One line for a footer, decided at build time: "v2.4.0 (12039) · a1b2c3d4 · 31 Aug 2026". */
export const BUILD_LABEL = 'v2.4.0 · ba248d16 · 06 Sep 2026';
